import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  box: {
    marginTop: theme.spacing(3),
    padding: `${theme.spacing(2)} 0`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: 0
    }
  },
  buttons: {
    width: '100%',
    minHeight: 48,
    borderWidth: '2px',
    [theme.breakpoints.up('sm')]: {
      width: '48%'
    },
    '&.Mui-disabled': {
      backgroundColor: theme.palette.action.disabledBackground,
      opacity: 1,
      color: theme.palette.text.disabled
    }
  },
  buttonMain: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover': {
      borderColor: '#FFFFFF',
      background: theme.palette.primary.dark,
      opacity: 0.8
    },
    '&:focus-visible': {
      outline: `3px solid ${theme.palette.primary.main}`,
      outlineOffset: '3px'
    }
  },
  field: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing()
  }
}));
